export const pathway = [
    {
        key: '7',
        name: 'What brings you to the Faculty of Education?',
        options: [
            {
                name: 'I am interested in work opportunities',
                results: true,
                value: '7.1.1',
            },
            {
                name: 'I want to become a counsellor',
                results: true,
                value: '7.1.2',
            },
            {
                name: 'I want to become a K-12 teacher',
                value: '3.1.1',
            },
            {
                name: 'I want to advance my knowledge and education',
                value: '6.1',
            },
        ]

    }
];

export const results = [
    {
        id: '7.1.1',
        primary: {
            links: [
                {
                    title: 'Work with us',
                    subtitle: 'Explore opportunities with the Faculty'
                }
            ]
        }
    },
    {
        id: '7.1.2',
        primary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in Counselling and Human Development ',
                    subtitle: 'Review the academic and experience prerequisites for the Master’s in Counselling Psychology programs',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/counselling-human-development-pbd.html'
                },
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Counselling Psychology MA, Med',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies/programs/counspsych.html'
                }
            ]
        }
    }
]
